module.exports = __webpack_public_path__ + "img/masahiro.6cca56a3.jpg";